export const ATTRIBUTE_NO_VALUE = '-';
